import styled from 'styled-components';

export const Wrapper = styled.div`
  background-image: linear-gradient(rgba(0,0,0, 0.7), rgba(0,0,0, 0.7)), url('/background_4.jpg');
  background-color: white;
  background-size: cover;
  width: 100%;
  height: 100vh;
  min-height: 100vh;
  overflow: auto;
  background-repeat: no-repeat;
  background-position: center center;
  background-attachment: fixed;
  position: relative;
  display: flex;
  align-items: stretch;
  justify-content: stretch;

  @media (max-width: 768px) {
    align-items: center;
    justify-content: center;
  }
`;

export const LeftPanel = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  min-height: 100vh;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const LeftPanelContent = styled.div`
  text-align: center;
  color: white;
  max-width: 500px;
`;

export const LeftPanelLogo = styled.img`
  width: 80px;
  height: 80px;
  margin-bottom: 24px;
`;

export const LeftPanelTitle = styled.h1`
  font-size: 36px;
  font-weight: 700;
  margin-bottom: 16px;
  color: white;
`;

export const LeftPanelDescription = styled.p`
  font-size: 18px;
  color: white;
  line-height: 1.6;
`;

export const RightPanel = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  min-height: 100vh;

  @media (max-width: 768px) {
    padding: 20px;
    width: 100%;
    max-width: 400px;
  }
`;

export const Language = styled.div`
  position: fixed;
  top: 0;
  right: 8px;
  padding: 12px;
  cursor: pointer;
  font-size: 24px;
  z-index: 99;
`;

export const Content = styled.div`
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Head = styled.div`
  text-align: center;
  margin-bottom: 32px;

  @media (max-width: 768px) {
    margin-bottom: 24px;
  }
`;

export const Logo = styled.img`
  width: 60px;
  height: 60px;
  margin-bottom: 16px;
`;

export const NameApp = styled.h1`
  font-size: 22px;
  font-weight: 500;
  letter-spacing: 0.11px;
  margin: 8px 0;
  color: #333;
`;

export const Description = styled.h6`
  font-size: 14px;
  color: #666;
  font-weight: 400;
  margin: 0;
`;

export const Children = styled.div`
  width: 100%;
`;

export const Support = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  column-gap: 30px;
  margin-top: 24px;
  justify-content: center;

  & a {
    color: #999;
    font-size: 14px;
    line-height: 22px;
    text-decoration: underline;

    &:hover {
      color: #666;
    }
  }

  @media (max-width: 768px) {
    margin-top: 20px;
  }
`;

export const Question = styled.div`
  position: fixed;
  bottom: 42px;
  right: 42px;
  padding: 12px;
  background-color: white;
  border-radius: 50%;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #666;
  z-index: 100;

  &:hover {
    background-color: #f5f5f5;
  }

  @media (max-width: 768px) {
    right: 20px;
    bottom: 20px;
  }
`;

// Mobile-only header
export const MobileHeader = styled.div`
  display: none;
  text-align: center;
  margin-bottom: 24px;

  @media (max-width: 768px) {
    display: block;
  }
`;

export const MobileLogo = styled.img`
  width: 48px;
  height: 48px;
  margin-bottom: 12px;
`;

export const MobileTitle = styled.h1`
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 4px 0;
  color: white;
`;

export const MobileDescription = styled.p`
  font-size: 12px;
  color: white;
  margin: 0;
`;
